import { useState } from "react"
import { BasicButton } from "../../../theme/Component/BasicButton"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { BasicTable, MASK_NUMBER } from "../../../theme/Component/BasicTable"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { _DocumentFactory, _single } from "../../../../core/services/dataBean/EntityCatalog"
import { ImportXLSX } from "../../../theme/Component/ImportXLSX"

export const ImportBankingAbstractAccount = () => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_DocumentFactory)


    const [data, setData] = useState<any>({})

    const importFunction = () => {
        instance.importAccountBank(_single.getAccountID(),JSON.stringify(data),true).then(
            (resp:any)=>{
                setLista(resp); 
            }
        )
    }

    const head = [
        { title: 'Tercero', property: 'EntityName', visible: true},
        { title: 'No Cuenta', property: 'AccountNumber', visible: true,mask:MASK_NUMBER},
        { title: 'Mensaje', property: 'Message', visible: true},
    ]

    return (
        <BasicPage titulo="Importar Cuentas Bancarias de Terceros" >
            <div className="row">
                <div className="col-md-8">
                    <ImportXLSX lodaData={setData} />
                </div>
                <div className="col-md-4">
                    <BasicButton eventClick={importFunction} icon="ri-send-plane-line" useMargin children={`Importar Cuentas`} />
                </div>
                <div className="col-md-12">
                    <strong>Formato Excel Columnas</strong><br />
                    <strong>CEDULA</strong> <small> Numero cedula sin puntos</small><br />
                    <strong>CUENTA</strong> <small> Numero Cuenta Bancaria</small><br />
                    <strong>IDBANCO</strong> <small> ID Banco de la tabla de entidades financieras</small><br />
                    <strong>IDTIPOCUENTA</strong> <small> ID Tipo cuenta</small>

                </div>

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} />
                    {/* {JSON.stringify(data)} */}
                </div>
            </div>
        </BasicPage>
    )
}